/**
 * 
 * @copyright     (c) 2024-2025 Gist Applications Inc.
 * @author        Greg Olive greg@gist-apps.com
 * @package       gift-card-pro
 * 
 * /assets/js/React/Proxy/pages/GiftCardForm/_sections/CardDelivery.js
 * Created:       Mon May 06 2024
 * Modified By:   Greg Olive
 * Last Modified: Tue Apr 22 2025
 */

import React, { useContext } from 'react';
import {FormSection,RadioButtonsMega} from "@proxy/_components";
import { TranslationsContext, FormContext } from '@proxy/_contexts';

export default function CardDelivery() {

  const translations = useContext(TranslationsContext);
  const {
    fulfillmentType,
    setFulfillmentType,
  }  = useContext(FormContext);

  const options = [
    {
      value: "digital",
      label: translations.digital_delivery_label,
      help: translations.digital_delivery_help,
      icon: './icons/letter.svg'
    },
    {
      value: "physical",
      label: translations.physical_delivery_label,
      help: translations.physical_delivery_help,
      icon: './icons/truck.svg'
    }
  ];

  return (
    <FormSection
      id="gcpCardDeliverySection"
      additionalClasses="gc__card-delivery-section"
      title={translations.card_delivery_heading}
    >
      <div className={"gc__delivery_selection_div"}>
        <RadioButtonsMega
          groupName={"gc_delivery_type"}
          name={"properties[_gcp_fulfillment_type]"}
          options={options}
          onChange={(v) => setFulfillmentType(v)}
          value={fulfillmentType || "digital"}
          classes={"gc__no_column_row_gap gc__delivery-radio-container"}
          variant="mega"
        />
      </div>
    </FormSection>
  );
}
